import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from '@mui/material';
import { primary, secondary } from '../../themes/colors';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useTranslation } from 'react-i18next';

const SessionExpiredDialog = ({ open }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleBackToLogin = () => {
    logout();
    navigate('/login', { replace: true });
  };

  return (
    <Dialog 
      open={open}
      maxWidth="sm"
      disableEscapeKeyDown
      disableAutoFocus
      PaperProps={{
        sx: {
          borderRadius: 2,
          padding: 1
        }
      }}
    >
      <DialogTitle sx={{ color: primary.main, fontWeight: 500 }}>
        {t('session_expired')}
      </DialogTitle>
      
      <DialogContent>
        <Typography variant="body1">
          {t('session_expired_message')}
        </Typography>
      </DialogContent>
      
      <DialogActions sx={{ padding: 2 }}>
        <Button 
          onClick={handleBackToLogin}
          variant="contained"
          fullWidth
          sx={{ 
            bgcolor: secondary.main,
            '&:hover': { 
              bgcolor: secondary.dark 
            },
            textTransform: 'none',
            fontWeight: 500
          }}
        >
          {t('back_to_login')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SessionExpiredDialog;